import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackMakeWishListPrivateParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackMakeWishListPrivate = (
    parameters: TrackMakeWishListPrivateParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "make_wishlist_private", ...parameters }, options);
};

export default trackMakeWishListPrivate;
